// extracted by extract-css-chunks-webpack-plugin
module.exports = {"observer":"observer_zDZ_i"};